export const getTokenMutation = /* GraphQL */ `
    mutation login($email: String!, $password: String!) {
        generateCustomerToken(email: $email, password: $password) {
            token
            reset_password
        }
    }
`
